import React from 'react';
import PropTypes from 'prop-types';

import { FILTER_PHOTOS_ONLY, FILTER_VIDEOS_ONLY } from 'constants/filters';

import { InputRadioGroup } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const AssetTypeToggle = ({ setAssetType, selectedAssetType }) => {
  const handleOnChange = (event) => {
    const assetType = event.target.value;
    setAssetType({ assetType });
  };

  return (
    <InputRadioGroup
      layout="inline"
      selectedValue={selectedAssetType || 'All'}
      id="asset-type-selector"
      label={translate('assetFeed.viewMenu.assetTypeToggle.title')}
      options={[
        {
          label: translate('assetFeed.viewMenu.assetTypeToggle.labelAll'),
          value: 'All',
          testId: 'view_menu__type-all',
        },
        {
          label: translate('assetFeed.viewMenu.assetTypeToggle.labelPhotos'),
          value: FILTER_PHOTOS_ONLY,
          testId: 'view_menu__type-photos-only',
        },
        {
          label: translate('assetFeed.viewMenu.assetTypeToggle.labelVideos'),
          value: FILTER_VIDEOS_ONLY,
          testId: 'view_menu__type-videos-only',
        },
      ]}
      onChange={handleOnChange}
    />
  );
};

AssetTypeToggle.propTypes = {
  setAssetType: PropTypes.func,
  selectedAssetType: PropTypes.string,
};

export default AssetTypeToggle;
